export default __webpack_public_path__ + "static/Gotham-Bold-fcd7dffc0ef1e81e6a421ee08598ed4c.woff";